export default __webpack_public_path__ + "static/media/clarity_filter-grid-circle-line.840b5da3.svg";